import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getIntakeEnabled } from "@/lib/intakeApi";

export function useIntakeOpen() {
  const [open, setOpen] = useState(null);
  useEffect(() => { getIntakeEnabled().then(setOpen); }, []);
  return open;
}

export const IntakeClosed = ({ loading }) =>
  loading ? <div data-testid="intake-status-loading" className="h-40" aria-busy="true" /> : (
    <div data-testid="intake-closed-message" role="status" className="max-w-2xl">
      <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-tone">Temporarily unavailable</p>
      <h1 className="mt-4 font-display text-3xl font-light tracking-[-0.03em] sm:text-4xl">We’re not taking new submissions just yet.</h1>
      <p className="mt-5 text-[15px] leading-relaxed text-subtle">
        This form is paused while we finish preparing it. Nothing has been collected. Please check back soon.
      </p>
      <Link to="/" data-testid="intake-closed-home-link" className="fa-link mt-8 inline-flex items-center gap-2 rounded-sm text-[14px] text-fg underline underline-offset-4">Back to home</Link>
    </div>
  );
